var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { display: "inline-block" } }, [
    _c(
      "div",
      { staticClass: "content-box" },
      [
        _c("span", { staticClass: "title-txt" }, [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _c(
          "el-select",
          {
            staticStyle: { width: "45px" },
            attrs: { placeholder: "" },
            model: {
              value: _vm.selectValue,
              callback: function ($$v) {
                _vm.selectValue = $$v
              },
              expression: "selectValue",
            },
          },
          _vm._l(_vm.options, function (item) {
            return _c("el-option", {
              key: item.value,
              attrs: { label: item.label, value: item.value },
            })
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input-box" },
          [
            _c("el-input", {
              attrs: { placeholder: "数值" },
              model: {
                value: _vm.inputValue,
                callback: function ($$v) {
                  _vm.inputValue = $$v
                },
                expression: "inputValue",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }